/* eslint-disable @typescript-eslint/no-explicit-any */
import { clearPlaylistAll } from '@/features/playlist/playlistSlice';
import { clearAuthAll, setIsGuest } from '@/features/spotifyAuth/authSlice';

export const logout = async (dispatch: any) => {
  const token = localStorage.getItem('token');
  window.localStorage.removeItem('token');
  dispatch(setIsGuest(false));
  dispatch(clearPlaylistAll());
  dispatch(clearAuthAll());

  return token;
};
